import { SxProps, Theme } from '@mui/material';

interface CommonButtonStyleOptions {
    selected?: boolean;
    login?: boolean;
    color?: string;
    needBackgroundColor?: boolean
}

export const commonButtonStyles = (
    theme: any,
    { selected = false, login = false, color = 'white', needBackgroundColor = false }: CommonButtonStyleOptions = {}
): SxProps => ({
    color: color,
    backgroundColor: !selected ? (! needBackgroundColor ?  'transparent': theme.palette.blue) : theme.palette.orange,
    border: `${theme.border.type.solid} ${theme.border.width.medium} ${
        !selected ? (login ? theme.palette.black : theme.palette.lightGrey) : theme.palette.orange
    }`,
    borderRadius: theme.border.radius.md,
    transition: 'background-color 0.5s',
    padding: theme.spacing.sm,
    textTransform: 'none',
    '&:hover': {
        backgroundColor: theme.palette.orange,
        borderColor: theme.palette.orange,
        border: `${theme.border.type.solid} ${theme.border.width.medium} ${theme.palette.white}`,
    },
    '&:disabled': {
        borderColor: theme.palette.lightGrey,
        color: theme.palette.lightGrey,
        border: `${theme.border.type.solid} ${theme.border.width.medium} ${theme.palette.lightGrey}`,
    },
    '&.Mui-disabled':{
        borderColor: theme.palette.lightGrey,
        color: theme.palette.lightGrey,
        border: `${theme.border.type.solid} ${theme.border.width.medium} ${theme.palette.lightGrey}`
    },
    '& .MuiButton-startIcon': {
        marginLeft: 0,
        marginRight: 0,
    },
});
